
    export default {
        props: {
            list: {
                type: Array,
                required: true
            },
            id: {
                type: String,
                default: 'tab1'
            }
        },
        data () {
          return {
            isMounted: false
          }
        },
        watch: {
          isMounted() {
            if (this.isMounted) {
              setTimeout(() => {
                this.insertDataContent()
              }, 500);
            }
          }
        },
        mounted() {
          this.isMounted = true
        },
        methods: {
            activeTab(e) {
              e.preventDefault();

              for(const element in this.$el.firstChild.children) {
                if(element < this.$el.firstChild.children.length) {
                  this.$el.firstChild.children[element].firstChild.classList.remove('active');
                }
              }

              for(const element in this.$el.lastChild.children) {
                if(element < this.$el.lastChild.children.length) {
                  this.$el.lastChild.children[element].classList.add('d-none');
                }
              }

              const tabContent = document.querySelector(e.target.getAttribute('href'));
              e.target.classList.add('active')
              tabContent.classList.remove('d-none')
            },
            insertDataContent() {
              for(const element in this.$el.lastChild.children) {
                if(element < this.$el.lastChild.children.length) {
                  this.$el.lastChild.children[element].appendChild(this.list[element].content);
                }
              }
            }
        }
    }
